import React, { useEffect, useState } from "react";
import { FaArrowDown, FaUsers } from "react-icons/fa";
import { Link } from "react-router-dom";
import User from "../../assets/images/User.png";
import Footer from "../../components/footer";
import GetUsers from "../../hooks/getUsers";
import FunctionalScoreIcon from "../../assets/images/1414907_IconsforPlatformFeatures5_DataAnalytics_072122.png";
import CarePlanIcon from "../../assets/images/1409153_IconsforPlatformFeatures4_Accountability_071422.png";
import CreateFunctionalScoreIcon from "../../assets/images/normal_u60.png";
import CreateCarePlanIcon from "../../assets/images/normal_u70.png";
import GetSinglePatient from "../../hooks/getSinglePatientProfile";

import { useAuth } from "../../services/authProvider";

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import moment from "moment";

const AdminPatientHomePage = (props) => {
  const { data, isLoading, error } = GetSinglePatient();
  const formatDate = (date) => {
    return moment(date).format("DD MMM YYYY");
  };

  return (
    <>
      <div className="container-fluid py-3 px-md-4 px-2 h-100 noScroll">
        <div className="card border-0 h-100">
          <div className="card-body px-md-3 px-2 mb-3 d-flex flex-column h-100">
            <div className="flex-shrink-0">
              <h5 className="font-weight-lighter mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                Admin: Patient Home Page
              </h5>
              <hr />
            </div>

            <div
              className="flex-grow-1 d-flex flex-column"
              style={{ minHeight: 0 }}
            >
              <div className="flex-grow-1">
                <div className="row h-100">
                  {isLoading && (
                    <div className="col-md-5">
                      <div className="card border-0 shadow-lg">
                        <div className="card-body">
                          <SkeletonTheme
                            baseColor="#e9ecef"
                            highlightColor="#f8f9fa"
                          >
                            <div className="text-center mt-3">
                              <Skeleton circle width={95} height={95} />
                            </div>
                            <div className="text-center my-4">
                              <Skeleton width={180} height={24} />
                            </div>
                            <div className="form-group mb-1 d-flex justify-content-between">
                              <label htmlFor="name">
                                <small>Name (Last, First):</small>
                              </label>
                              <label htmlFor="name" className="">
                                <small>
                                  <Skeleton width={120} height={12} />
                                </small>
                              </label>
                            </div>
                            <div className="form-group mb-1 d-flex justify-content-between">
                              <label htmlFor="name">
                                <small>Date of Birth:</small>
                              </label>
                              <label htmlFor="name" className="">
                                <small>
                                  <Skeleton width={100} height={12} />
                                </small>
                              </label>
                            </div>
                            <div className="form-group mb-1 d-flex justify-content-between">
                              <label htmlFor="name">
                                <small>Age:</small>
                              </label>
                              <label htmlFor="name" className="">
                                <small>
                                  <Skeleton width={30} height={12} />
                                </small>
                              </label>
                            </div>
                            <div className="form-group mb-1">
                              <label htmlFor="name">
                                <small>Gender Identity:</small>
                              </label>
                              <div className="mt-1">
                                <small>
                                  <Skeleton width={80} height={12} />
                                </small>
                              </div>
                            </div>
                            <div className="form-group mb-1 d-flex justify-content-between">
                              <label htmlFor="name">
                                <small>Biological Sex:</small>
                              </label>
                              <label htmlFor="name" className="">
                                <small>
                                  <Skeleton width={60} height={12} />
                                </small>
                              </label>
                            </div>
                            <div className="form-group mb-1">
                              <label htmlFor="name">
                                <small>OHIP:</small>
                              </label>
                              <div className="mt-1">
                                <small>
                                  <Skeleton width={100} height={12} />
                                </small>
                              </div>
                            </div>
                          </SkeletonTheme>
                        </div>
                      </div>
                    </div>
                  )}

                  {data && (
                    <div className="col-md-5">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="text-center">
                            <div className="d-flex justify-content-between">
                              <div>
                                <img
                                  src={User}
                                  width={95}
                                  height={95}
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>
                              <div>
                                <h5 className="text-center">
                                  POMMe ID: {data?.data?.pommeId}
                                </h5>
                              </div>
                            </div>
                          </div>
                          <h5 className="text-center">Patient Profile</h5>
                          <div className="form-group mb-1 d-flex justify-content-between">
                            <label htmlFor="name">
                              <small>Name:</small>
                            </label>
                            <label htmlFor="name" className="">
                              <small>
                                {data?.data?.lastName}, {data?.data?.firstName}
                              </small>
                            </label>
                          </div>
                          <div className="form-group mb-1 d-flex justify-content-between">
                            <label htmlFor="name">
                              <small>Date of Birth:</small>
                            </label>
                            <label htmlFor="name" className="">
                              <small>{formatDate(data?.data?.dob)}</small>
                            </label>
                          </div>
                          <div className="form-group mb-1 d-flex justify-content-between">
                            <label htmlFor="name">
                              <small>Age:</small>
                            </label>
                            <label htmlFor="name" className="">
                              <small>{data?.data?.age}</small>
                            </label>
                          </div>
                          <div className="form-group mb-1 d-flex justify-content-between">
                            <label htmlFor="name">
                              <small>Gender Identity:</small>
                            </label>
                            <label htmlFor="name" className="">
                              {data?.data?.gender}
                            </label>
                          </div>
                          <div className="form-group mb-1 d-flex justify-content-between">
                            <label htmlFor="name">
                              <small>Biological Sex:</small>
                            </label>
                            <label htmlFor="name" className="">
                              {data?.data?.sex === "FEMALE" ? "Female" : "Male"}
                            </label>
                          </div>
                          <div className="form-group mb-1 d-flex justify-content-between">
                            <label htmlFor="name">
                              <small>OHIP:</small>
                            </label>
                            <label htmlFor="name" className="">
                              <small>{data?.data?.ohip}</small>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-md-6">
                    <h5 className="text-center pb-2">Tasks Available</h5>
                    <div className="">
                      <div className="row justify-content-center">
                        <div className="d-flex align-items-center mb-2">
                          <label
                            htmlFor=""
                            className="font-weight-bold text_primary"
                          >
                            Step 1
                          </label>
                          <button className="btn btn-primary w-236 h-40 ml-3 mx-4 fs-13">
                            Enter Functional Scores
                          </button>
                          <img
                            src={CreateFunctionalScoreIcon}
                            height={45}
                            alt=""
                          />
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <label
                            htmlFor=""
                            className="font-weight-bold text_primary"
                          >
                            Step 2
                          </label>
                          <button className="btn btn-primary w-236 h-40 ml-3 mx-4 fs-13">
                            View Functional Summaries
                          </button>
                          <img src={FunctionalScoreIcon} height={45} alt="" />
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <label
                            htmlFor=""
                            className="font-weight-bold text_primary"
                          >
                            Step 3
                          </label>
                          <button className="btn btn-primary w-236 h-40 ml-3 mx-4 fs-13">
                            Create Care Plan
                          </button>
                          <img src={CreateCarePlanIcon} height={45} alt="" />
                        </div>
                        <div className="d-flex align-items-center">
                          <label
                            htmlFor=""
                            className="font-weight-bold text_primary"
                          >
                            Step 4
                          </label>
                          <button className="btn btn-primary w-236 h-40 ml-3 mx-4 fs-13">
                            View Care Plan Summaries
                          </button>
                          <img src={CarePlanIcon} height={45} alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      <div className="card w-236 d-flex justify-content-center">
                        <div className="d-flex align-items-center justify-content-center py-3">
                          <h6 className="my-0 p-0 mr-2">Collaborators</h6>
                          <FaUsers size={18} />
                        </div>
                        <div className="d-flex align-items-center justify-content-center mb-4">
                          <div className="">
                            <div className="d-flex justify-content-between align-items-center fs-13 mb-3">
                              <small className="mr-3">
                                Healthcare Providers
                              </small>
                              <small className="font-weight-bold">7</small>
                            </div>
                            <div className="d-flex justify-content-between align-items-center fs-13">
                              <small className="mr-3">Family</small>
                              <small className="font-weight-bold">2</small>
                            </div>
                          </div>
                          <a
                            href="#"
                            data-toggle="modal"
                            data-target="#collaboratorsModal"
                            className="text_primary border-primary px-4 rounded ml-3"
                          >
                            <i className="fa fa-chevron-right" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Collaborators Modal */}
      <div
        className="modal fade"
        id="collaboratorsModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content pt-3">
            <div className="modal-header border-0">
              <div className="flex-grow-1 text-center">
                <h5 className="text_primary" style={{ fontWeight: 500 }}>
                  <i className="fa fa-users" /> &nbsp;Collaborators
                </h5>
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span
                  className="text_primary"
                  style={{ fontSize: 40, fontWeight: "600" }}
                  aria-hidden="true"
                >
                  &times;
                </span>
              </button>
            </div>
            <div className="modal-body mt-2 mx-2">
              <div className="border py-2 rounded">
                <small className="mx-3">Healthcare Providers</small>
              </div>
              <div className="mx-3 pt-2">
                {/* Healthcare providers list would be populated here */}
                <p className="mb-0 pb-2">
                  <small>Loading healthcare providers...</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdminPatientHomePage;
